<template lang="pug" src="./photo-report-review.pug"> </template>
<style lang="scss" src="./photo-report-review.scss" scoped> </style>

<script>
import store from '@/store';
import { mapState } from 'vuex';
import reviewDialog from './review-dialog';
import completeDialog from './complete-dialog';

export default {
    components: {
        'v-review-dialog': reviewDialog,
        'v-complete-dialog': completeDialog
    },
    data: () => ({
        reviewDialog: false,
        completeDialog: false,
        images: [],
        requestDriverId: null,
        filters: {
            startDate: null,
            endDate: null,
            brandId: null,
            status: null,
            page: 1,
            q: null
        },
        startDateModal: false,
        endDateModal: false
    }),
    beforeRouteEnter: function(to, from, next) {
        store.dispatch('photoReports/getPhotoReportById', { id: to.params.id }).then(() => {
            next();
        });
    },
    computed: {
        ...mapState({
            photoReport: (state) => state.photoReports.photoReport,
            pagination: (state) => state.photoReports.pagination,
            brands: (state) => state.data.brands
        }),
        isReportFinished() {
            return ['close'].includes(this.photoReport.requestStatus);
        },
        reportName() {
            if (!this.photoReport.requestName) {
                return '';
            }

            return this.photoReport.requestName;
        },
        headers() {
            return [
                '#', 'callSign', 'brand', 'name',
                'auto', 'phoneNumber', 'driverCreatedAt',
                'commission', 'images', 'status', 'comment'
            ].map((it) => ({
                text: this.$vuetify.lang.t(`$vuetify.pages.PhotoReport.review.table.${it}`),
                value: it,
                sortable: false,
                align: 'center'
            }));
        },
        statuses() {
            return [
                { value: 'new', isDisabled: true },
                { value: 'empty', isDisabled: true },
                { value: 'remake', isDisabled: true },
                { value: 'accepted', isDisabled: false },
                { value: 'rejected', isDisabled: false }
            ].map(it => ({
                text: this.$vuetify.lang.t(`$vuetify.pages.PhotoReport.statuses.${it.value}`),
                value: it.value,
                isDisabled: it.isDisabled
            }));
        }
    },
    created: function() {
        this.$store.dispatch('data/getBrands');
    },
    methods: {
        changeEndDate() {
            this.endDateModal = false;
        },

        changeStartDate() {
            this.startDateModal = false;
        },

        applyFilters() {
            this.getPhotoReportByPage();
        },

        resetFilters() {
            this.filters = {
                startDate: null,
                endDate: null,
                status: null,
                q: null,
                brandId: null
            };

            this.getPhotoReportByPage();
        },

        getPhotoReportByPage(page = 1) {
            this.$store.dispatch('photoReports/getPhotoReportById', {
                ...this.filters,
                id: this.$route.params.id,
                page
            });
        },

        openReviewDialog(driver) {
            this.requestDriverId = driver.requestDriverId;
            this.$store.commit('photoReports/SET_IMAGES', driver.images);
            this.reviewDialog = true;
        },

        openCompleteDialog() {
            this.completeDialog = true;
        },

        editDriverStatus(driver) {
            this.$store.dispatch('photoReports/editDriverStatus', {
                requestDriverId: driver.requestDriverId,
                status: driver.status
            });
        },

        editDriverComment(driver) {
            this.$store.dispatch('photoReports/editDriverComment', {
                requestDriverId: driver.requestDriverId,
                comment: driver.comment
            });
        },

        isStatusDisabled(status) {
            return ['empty', 'accepted', 'rejected'].includes(status) || this.isReportFinished;
        }
    }
};
</script>
